import ValidationConstants from './constants/validation.constants.js';
import EVENTS from './constants/xray-ui_events.constants';


/**
 * providers configurations
 * @param $urlRouterProvider
 */
function appConfig($httpProvider) {

    /* IE Promise refresh issue fix */

    //initialize get if not there
    if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
    }

    // Answer edited to include suggestions from comments
    // because previous version of code introduced browser-related errors

    //disable IE ajax request caching
    $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
    // extra
    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
    $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';

    /* end fix */

 /*   $urlRouterProvider.otherwise(function ($injector, $location) {
        if ($location.path() === '' || $location.path() === '/') {
            return '/home';
        } else {
            return '/404';
        }
    });*/

    $httpProvider.interceptors.push('xrayRestCallsInterceptor');
    //$httpProvider.interceptors.push('licenseValidityInterceptor');
   // $httpProvider.interceptors.push('xraySessionInterceptor');
    //$httpProvider.interceptors.push('XRayUISpinnerInterceptor');
    //$locationProvider.hashPrefix('');
}

function appRun($location, $httpBackend, $rootScope, $timeout, $animate, XRayUIState, XRayUIStorage,
                XRayUIWebsocketInterface,
                XRayUIWebsocketMessageHandler) {

    let sessionData = XRayUIStorage.getItem('sessionData');
    if (sessionData) {
        XRayUIState.setState('sessionData', sessionData);
    }


    XRayUIState.setState('settingsMenuLocation', 'sidebar'); // 'upperRight' / 'sidebar'

    $httpBackend.whenPOST(/.*/).passThrough();
    $httpBackend.whenPUT(/.*/).passThrough();
    $httpBackend.whenGET(/.*/).passThrough();
    $httpBackend.whenDELETE(/.*/).passThrough();
    $httpBackend.whenPATCH(/.*/).passThrough();

    XRayUIWebsocketInterface.connect(XRayUIWebsocketMessageHandler);

}

angular.module('xray.ui', [
    'jfrog.ui.essentials',
    // Vendor modules
    'ngMessages',
    'ngAnimate',
    'ui.utils',
    'ui.select',
    'selectize',
    'ui.codemirror',
    'ngPasswordStrength',
    'cfp.hotkeys',
   // 'xray-ui.templates',
    'ui.router',
    'chart.js',
    'ngCookies',
    'toaster',
    'ngSanitize',
    'ui.layout',
    'ui.bootstrap',
    'ngMockE2E',
    'xray-ui.services',
    'xray-ui.directives',
    'xray-ui.dao',
   'xray-ui.states',
    'xray-ui.filters',
    'ui.grid.draggable-rows',
    'rzModule',
    'daterangepicker'
])
    .config(appConfig)
    //.run(appRun);




// WEBPACK FOOTER //
// ./modules/xray/app.js